(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.course.name)
      .directive(app.modules.course.directives.coursepicker, CoursePickerDirective);

   CoursePickerDirective.$inject = ["$timeout", "ngDialog", "$q"
      , app.modules.common.services.functions
      , app.modules.common.constants.appmessaging
      , app.modules.course.services.search
      , app.modules.common.constants.appsettings
      , app.modules.common.services.storage
   ];

   function CoursePickerDirective($timeout, ngDialog, $q
       , ggFunctions
       , ggMessaging
       , ggCourseSearchSvc
       , appSettings
       , ggStorage
       ) {

      var ctrl = this;

      return {
         restrict: "A"
         , templateUrl: "app/course/directives/coursepicker.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {

            var isUpdateView = true;

            scope.cp = {
                view : {
                  tabs : {
                     current : 3
                     , types : {
                        search : 1
                        , location : 2
                        , favs: 3
                        , tees : 4
                     }
                     , isActive: function (tab) {
                        return scope.cp.view.tabs.current == tab;
                     }
                     , select: function (tab) {
                        if (!tab) {
                           tab = scope.cp.view.tabs.current;
                        }
                        
                        scope.cp.isError = false;
                        scope.cp.msg = "There were no courses found.";
                        if (tab != scope.cp.view.tabs.types.tees) {
                            scope.cp.dialog.search.reset(tab);
                        }

                        scope.cp.view.tabs.current = tab;
                     }
                  }
               }
               , window: ggFunctions.fetchWindowSize()
               , defaultText : "Choose a Golf Course"
               , courseId: 0
               , Course: {
                  id: 0
                  , name: ""
                  , address: {
                     city: ""
                     , region : ""
                  }
                  , tees: []
               }
               , Tee: {}
               , teeId: 0
               , defaultView: 1
               , isTees: false
               , isSearch: false
               , isLoaded: false
               , isError: false
               , gender: app.Member.Detail.gender || ""
               , handicap : null
               // Pick course from select box to open modal
               , pickCourse: function () {
                  ngDialog.closeAll();

                  app.Member.Session.pageTemplates.fetch("app/course/directives/coursepicker-modal.html").then(function (template) {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                     }

                     var _coursePicker = ngDialog.open({
                        template: template
                        , plain: true
                        , closeByEscape: true
                        , closeByDocument: true
                        , className: "slideup picker course"
                        , scope: scope
                     });

                     _coursePicker.closePromise.then(function () {
                        if (isCordova && isCordovaReady) {
                           StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                        }
                     });
                  });


                  

                  if (scope.cp.Course && (!scope.cp.Course.id || scope.cp.Course.id != scope.cp.courseId)) {
                      scope.cp.teeId = 0;
                      scope.cp.courseId = 0;
                  }

                  if (scope.cp.defaultView == 2 && scope.cp.teeId == 0) {
                     scope.cp.view.tabs.select(scope.cp.view.tabs.types.location);
                  }
                  if (scope.cp.defaultView == 3) {
                      scope.cp.Course.id = 0;
                      scope.cp.courseId = 0;
                      scope.cp.teeId = 0;
                     scope.cp.view.tabs.select(scope.cp.view.tabs.types.favs);
                  }
                  
                  

               }
               , fetchCourseHandicap: function (slope) {
                   if (scope.cp.handicap && scope.cp.handicap.value != null && scope.cp.handicap.value != 99.9) {
                       return Math.round(scope.cp.handicap.value * slope / 113, 0);
                   } else {
                       return "n/a";
                   }
               }
               , dialog: {
                  alert: ""
                  , name: ""
                  , isProcessing: false
                  , isSearch: false
                  // Favorite if none selected
                  , favorite: function (course, tees) {

                     var courseId = app.Member.Detail.preferenceSettings.defaultCourseId || 0;
                     var teeId = app.Member.Detail.preferenceSettings.defaultTeeId || 0;

                     if ((courseId == 0 && course && course.id) || (teeId == 0 && course.tees)) {
                         var form = angular.copy(app.Member.Detail);
                         form.preferenceSettings.defaultCourseId = course.id;
                         if (tees) {
                             form.preferenceSettings.defaultTeeId = tees.id;
                         }
                         
                         return app.Member.Network.SaveAccountDetail(form).then(function(data){
                             app.Member.Detail.preferenceSettings = data.data.preferenceSettings;
                             ggStorage.set(ggStorage.keys.member.prefs.course.courseObj, course);
                             return app.Member.Network.Data.Courses.follow(course);
                         });
                     } else {
                         if (!app.Member.Network.Data.Courses.isFollowing(course.id)) {
                             return app.Member.Network.Data.Courses.follow(course);
                         } else {
                             return $q.resolve();
                         }
                     }
                  }
                  // Select course from search results
                  , selectCourse: function (course) {
                      if (course) {

                          scope.cp.Course = course;
                          scope.cp.courseId = course.id;

                          scope.cp.Tee = {};

                          ggCourseSearchSvc.search.fetchCourseDetail({courseId : course.id}).then(function (data) {
                              if (data && data.status == 200) {
                                  if (data.data && data.data.length > 0) {
                                      scope.cp.Course = data.data[0];
                                      course = scope.cp.Course;

                                      if (!scope.cp.isTees) {
                                          scope.cp.dialog.favorite(course).then(function () {
                                              scope.callback()(course);
                                          });
                                      }
                                  } else {
                                      if (!scope.cp.isTees) {
                                          scope.callback()(course);
                                      }
                                  }
                              }
                          }).finally(function () {

                              scope.cp.dialog.isProcessing = false;
                              if (!scope.cp.isTees) {
                                  ngDialog.closeAll();
                                  // Reset form
                                  scope.cp.dialog.name = "";
                                  scope.cp.dialog.search.results = [];
                              } else {
                                  scope.cp.view.tabs.select(scope.cp.view.tabs.types.tees);
                              }
                              
                          });

                        
                     }
                  }
                  // Select a Tee from the Course Tee Results
                  , selectTee: function (teeId) {
                    
                     var tee = null;

                     for (var x = 0; x < scope.cp.Course.tees.length; x++) {
                         tee = angular.copy(scope.cp.Course.tees[x]);
                        if (tee.id == teeId) {
                           scope.cp.Tee = tee;
                           scope.cp.teeId = teeId;
                           break;
                        }
                     }

                     if (tee){
                         return scope.cp.dialog.favorite(scope.cp.Course, tee).finally(function () {
                             scope.callback()(scope.cp.Course, tee);
                             ngDialog.closeAll();
                             scope.cp.dialog.isProcessing = false;
                         });
                     }
                     

                  }
                  , intellisense: {
                      isChanged : false
                      , isLoading: false
                      , timer : null
                      , change: function () {
                          if (scope.cp.dialog.name && scope.cp.dialog.name.length > 2
                              && !scope.cp.dialog.isProcessing
                              ) {
                                scope.cp.dialog.intellisense.isChanged = true;
                            } else {
                                scope.cp.dialog.search.results = [];
                                scope.cp.dialog.intellisense.isChanged = false;
                            }
                            if (scope.cp.dialog.intellisense.isChanged) {
                                scope.cp.dialog.intellisense.fetch();
                            }
                      }
                      , fetch: function () {
                          scope.cp.dialog.intellisense.isLoading = true;
                          scope.cp.dialog.intellisense.isChanged = false;
                          scope.cp.dialog.isProcessing = true;
                          ggCourseSearchSvc.search.fetchCourseSearch({ name: scope.cp.dialog.name }).then(function (data) {
                              var results = data.data.value;
                              if (results.length == 0) {
                                  scope.cp.dialog.alert = "There were no courses found matching your search.";
                              } else {
                                  scope.cp.dialog.alert = "";
                              }
                              scope.cp.dialog.search.results = results;
                              scope.cp.dialog.search.cache.bysearch = results;

                          }, function (fail) {
                              scope.cp.dialog.alert = "There was an error searching for golf courses.";
                          }).finally(function () {
                              scope.cp.dialog.intellisense.isLoading = false;
                              scope.cp.dialog.isProcessing = false;
                              if (scope.cp.dialog.intellisense.isChanged) {
                                  scope.cp.dialog.intellisense.fetch();
                              }
                          });
                      }
                  }
                  , search: {
                     results: []
                     , tees: []
                     , cache: {
                        bygps: []
                        , byme: []
                        , bysearch : []
                     }
                     , isDirty : false
                     , type: 1 // 1: Name, 2: GPS , 3: My
                     , fetch: function (form) {

                        var promise = null;
                        if (scope.cp.dialog.search.type == 2) {
                            promise = app.Member.Network.Data.Courses.location.fetch(true, form.latitude, form.longitude);
                        }
                        if (scope.cp.dialog.search.type == 3) {
                            promise = app.Member.Network.Data.Courses.fetch(form);
                        }

                        scope.cp.dialog.isProcessing = true;
                        promise.then(function (data) {
                            var results = [];
                            if (data && data.status) {
                                results = data.data.value;
                                if (results.length == 0) {
                                scope.cp.dialog.alert = "There were no courses found matching your search.";
                                } else {
                                scope.cp.dialog.alert = "";
                                }
                                
                            } else {
                                results = data;
                              if (data && data.length == 0) {
                                 scope.cp.dialog.alert = "There were no courses in your favorites.";
                              }
                              
                            }

                            scope.cp.dialog.search.results = results;
                            // Cache My and GPS
                            if (scope.cp.dialog.search.type == 2) {
                                scope.cp.dialog.search.cache.bygps = results;
                            }
                            if (scope.cp.dialog.search.type == 3) {
                                scope.cp.dialog.search.cache.byme = results;
                            }
                        
                        }).finally(function () {
                           scope.cp.dialog.isProcessing = false;
                           scope.cp.dialog.isSearch = true;
                        });
                     }
                     , reset: function (current) {
                        scope.cp.courseId = 0;
                        scope.cp.teeId = 0;
                        scope.cp.dialog.isSearch = false;
                        scope.cp.dialog.search.results = [];
                        if (current == scope.cp.view.tabs.types.location) {
                           scope.cp.dialog.search.byGps();
                        }
                        if (current == scope.cp.view.tabs.types.favs) {
                            scope.cp.dialog.search.byMember();
                        }
                        if (current == scope.cp.view.tabs.types.search) {
                            scope.cp.dialog.search.bySearch();
                        }
                     }
                     , byGps: function () {
                        scope.cp.dialog.search.type = 2;
                        if (scope.cp.dialog.search.cache.bygps.length > 0) {
                           scope.cp.dialog.search.results = scope.cp.dialog.search.cache.bygps;
                           scope.cp.dialog.isSearch = true;
                        } else {

                           // Get Location
                           var location = app.Member.Network.Data.Location;
                           var latitude = null;
                           var longitude = null;

                           var msg = "";
                           var isValid = false;

                           scope.cp.dialog.isProcessing = true;

                           location.locate(function () {
                              if (location.isCurrent) {
                                 latitude = location.latitude;
                                 longitude = location.longitude;
                                 scope.cp.dialog.search.fetch({ latitude: latitude, longitude: longitude });

                                
                              } else {
                                 scope.cp.isError = true;
                                 scope.cp.dialog.isSearch = true;
                                 scope.cp.dialog.alert = "Unable to access location services.";
                                 scope.cp.dialog.isProcessing = false;
                              }
                           });




                           
                        }
                     }
                     , byMember: function () {
                        scope.cp.dialog.search.type = 3;
                        if (scope.cp.dialog.search.cache.byme.length > 0) {
                           scope.cp.dialog.search.results = scope.cp.dialog.search.cache.byme;
                           scope.cp.dialog.isSearch = true;
                        } else {
                           scope.cp.dialog.search.fetch(false);
                        }
                     }
                    , bySearch: function () {
                        scope.cp.dialog.search.results = scope.cp.dialog.search.cache.bysearch;
                    }
                  }
               }
            }


            var loadOptions = function(objStr, isUpdate){
               if (objStr) {
                var obj = JSON.parse(objStr);
                  if (obj) {

                     // Default View
                     if (obj.defaultView) {
                        scope.cp.defaultView = Number(obj.defaultView);
                        if (scope.cp.defaultView == 2) {
                           scope.cp.defaultView = 3;
                        }
                     }

                     // Are we picking tees?
                     if (obj.isTees) {
                        scope.cp.isTees = true;
                     }

                      // Has a tee already been selected?
                     if (obj.teeId && obj.teeId != scope.cp.teeId) {
                        scope.cp.teeId = Number(obj.teeId);
                     }

                     // Was a course object provided?
                     if (obj.courseObj) {
                        scope.cp.Course = obj.courseObj;
                     }
                     
                     // Has a course been selected
                     if (obj.courseId && obj.courseId != scope.cp.courseId) {
                        scope.cp.courseId = Number(obj.courseId);
                     }
                     
                     // Default Course Text
                     if (obj.defaultText && (!scope.cp.Course.name || scope.cp.Course.name == "")) {
                         scope.cp.Course.name = obj.defaultText;
                         scope.cp.defaultText = obj.defaultText;
                     } else {
                        if (!scope.cp.Course.name || scope.cp.Course.name == "") {
                           scope.cp.Course.name = scope.cp.defaultText;
                        }
                     }

                     // Member Handicap
                     scope.cp.handicap = app.Member.Handicap.official;

                     // Fetch Course
                     fetchCourse();


                  }
               }
               
            },
            fetchCourse = function () {
               var isFetch = true;
               if (scope.cp.courseId > 0) {

                  if ((scope.cp.Course && scope.cp.Course.name && scope.cp.Course.name == scope.cp.defaultText) || (scope.cp.Course && scope.cp.Course.id && scope.cp.Course.id == scope.cp.courseId)) {
                      isFetch = false;

                      var defaultCourseId = app.Member.Detail.preferenceSettings.defaultCourseId || 0;
                      var defaultTeeId = app.Member.Detail.preferenceSettings.defaultTeeId || 0;
                      var defaultCourse = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.course.courseObj)) || {};
                      if (defaultCourse && defaultCourse.id && scope.cp.courseId == defaultCourseId) {
                          scope.cp.Course = defaultCourse;
                      }

                      if (scope.cp.Course && (!scope.cp.Course.id || scope.cp.Course.id != scope.cp.courseId)) {
                          if (defaultCourseId && !defaultCourse.id || defaultCourseId != defaultCourse.id) {
                              isFetch = true;
                          }
                      }
                      
                  }

                  

                  var processCourseDetail = function (isCB) {

                     var tee = null;
                     if (scope.cp.isTees && scope.cp.Course.tees && scope.cp.Course.tees.length > 0)
                        for (var x = 0; x < scope.cp.Course.tees.length; x++) {
                           tee = scope.cp.Course.tees[x];
                           if (tee.id == scope.cp.teeId) {
                              scope.cp.Tee = tee;
                              scope.cp.teeId = tee.id;
                              scope.cp.view.tabs.select(scope.cp.view.tabs.types.tees);
                              break;
                           }
                        }

                     scope.cp.isLoaded = true;

                     // callback on load
                     if (isCB) {
                        scope.callback()(scope.cp.Course, tee);
                     }
                     
                  }

                  if (isFetch) {
                     scope.cp.dialog.isProcessing = true;
                      ggCourseSearchSvc.search.fetchCourseDetail({ courseId: scope.cp.courseId }).then(function (data) {
                          if (data && data.status == "200") {
                              if (data.data && data.data.length > 0) {
                                  scope.cp.Course = data.data[0];
                                  processCourseDetail(true);
                              }
                        }
                     }, function (error) {
                        console.log(error);
                     }).finally(function () {
                        scope.cp.dialog.isProcessing = false;
                     });
                  } else {
                     processCourseDetail(false);
                  }
               }
               else {
                  scope.cp.isLoaded = true;
               }
            }
            

            ////////////////////////////////////////

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });


         }
      }
   }
}(angular, app));
